import { render, staticRenderFns } from "./effect-test.vue?vue&type=template&id=04404172"
import script from "./effect-test.vue?vue&type=script&lang=js"
export * from "./effect-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports